module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("aYVrY"))).then(() => parcelRequire('5Ijq4'));